import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {LoginService} from '../../services/api/login.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  @ViewChild('password') passwordElement!: ElementRef;

  loginForm = this.fb.group({
    mail: ['', Validators.required],
    password: ['', Validators.required],
  });
  error = '';
  passwordHide = true;

  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
  ) {
  }

  ngOnInit(): void {
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.loginForm.valid) {
      this.error = '';
      this.loginService.login(
        this.loginForm.controls.mail.value,
        this.loginForm.controls.password.value)
        .catch(error => {
          this.error = 'Не удалось выполнить вход';
          this.loginForm.controls.password.setValue('');
          setTimeout(() => {
            this.passwordElement.nativeElement.focus();
          }, 0);
        });
    }
  }

}
